import React from 'react'
import { useTranslation } from 'react-i18next'

function RemMaxLimit ({ remainingMaxLimit, maxLimit }) {
  const isMaxLimitLow = maxLimit <= 0
  const isRemainingLow = remainingMaxLimit <= 0
  const { t } = useTranslation()
  return (
    <div className='inline-flex items-center gap-2 sm:gap-2.5 bg-gray-100 rounded-md px-2.5 sm:px-3 py-1 sm:py-1.5 border border-gray-200'>
      <span className='inline-flex items-center gap-1 sm:gap-1.5'>
        <span className='text-[10px] sm:text-[11px] text-gray-500 font-medium tracking-wide'>
          {t('MAX LIMIT')}
        </span>
        <span
          className={`text-[11px] sm:text-xs font-semibold whitespace-nowrap ${
            isMaxLimitLow ? 'text-red-600' : 'text-black-700'
          }`}
        >
          {maxLimit}
        </span>
      </span>

      <span className='w-1 h-1 sm:w-1.5 sm:h-1.5 rounded-full bg-gray-300 flex-shrink-0' />

      <span className='inline-flex items-center gap-1 sm:gap-1.5'>
        <span className='text-[10px] sm:text-[11px] text-gray-500 font-medium tracking-wide'>
          {t('REM LIMIT')}
        </span>
        <span
          className={`text-[11px] sm:text-xs font-semibold whitespace-nowrap ${
            isRemainingLow ? 'text-red-600' : 'text-black-700'
          }`}
        >
          {remainingMaxLimit?.toFixed(2)}
        </span>
      </span>
    </div>
  )
}

export default RemMaxLimit
